import React, { Component } from "react";
import { Spin } from "antd";

export default class LoadingHold extends Component {
  render() {
    let { type, height } = this.props;

    if (type) {
      switch (type) {
        case "small":
          height = 50;
          break;
        default:
          break;
      }
    }
    return (
      <Spin spinning>
        <div style={{ height: height || window.outerHeight / 2 }} />
      </Spin>
    );
  }
}
